<template>
	<div>
		<div class="product-canvas"style="width:667px;height:606px;position: relative;">
		  <canvas id="areaCanvas"  width="667" height="606"> 
		  </canvas>
		  <div  id="textContent" class="tip-content">
			  <div class="tip" v-for="(num,index) in selectedContent" v-show="index==infoIndex">{{num.name}}{{num.content}}</div>
		  </div>
		</div>
		
	</div>
</template>
 
<script>
	//[148,221],[256,182],[367,167],[495,189],[525,209],[525,229],[506,234],[501,245],[486,251],[477,294],[356,267],[393,264],[203,281],[196,252],[162,241],[148,221]
  var inside = require('point-in-polygon');
  export default {
    data () {
      return {
        moltenIronLadleArr:{		
				zh:[
					{name:'包口',content:"配置抗热震性能和抗冲刷性能优良的ASC材质浇注料",
					point:[[141,96],[157,82],[183,75],[203,70],[252,64],[275,64],[294,82],[364,160],[294,173],[228,189],[170,208],[169,208],[147,218],[140,177],[138,144]]
					},
					{name:'扎线区域',content:"配置抗渣性好抗氧化性能优良的ASC砖",
					point:[[148,221],[256,182],[367,167],[495,189],[525,209],[525,229],[506,234],[501,245],[486,251],[477,294],[393,264],[203,281],[196,252],[162,241],[148,221]]
					},
					{name:'铁线区域',content:"配置抗氧化，抗剥落性能优良的ASC砖",
					point:[[205,283],[263,269],[315,265],[378,270],[427,281],[475,303],[457,452],[376,424],[326,418],[285,425],[241,437],[213,449]],
					},
					{name:'非冲击区',content:"配置强度高，整体性能优良的ASC砖",
					point:[[212,453],[250,436],[295,424],[337,422],[379,428],[408,436],[461,457],[455,538],[388,508],[416,484],[337,444],[251,488],[250,497],[270,511],[216,536]]
					},
					{name:'冲击区',content:"配置高强度，耐冲击的ASC砖",
					point:[[388,508],[416,484],[337,444],[251,488],[250,497],[270,511],[330,484]],
					},
					{name:'永久层',content:"配置烧成蜡石砖",
					point:[[492,253],[496,254],[487,309],[476,406],[463,549],[458,552],[329,494],[213,552],[208,550],[192,319],[187,260],[193,256],[198,325],[211,543],[218,544],[329,489],[454,544],[481,306]],
					},
					{name:'保温层',content:"配置高强度轻质保温板",
					point:[[496,254],[487,309],[476,406],[463,549],[458,552],[329,494],[213,552],[208,550],[192,319],[187,260],[182,262],[187,320],[202,551],[207,557],[328,501],[458,557],[467,554],[469,548],[491,309],[499,253]],
					}
					],
				en:[],
				ko:[],
				ja:[]			
			},
	    selectedContent:{},		
        collectionArr:[],
        isShowContent:false,
		infoIndex:null
      }
    },
    mounted() {
	  this.selectedContent=	this.moltenIronLadleArr.zh;
      this.getDrawPolygon(this.selectedContent)
      // this.collectionArr.push([[20,30],[50,30],[50,50],[20,50]]);
      // this.collectionArr.push([[60,3],[50,20],[70,40],[80,30],[70,20],[80,0]]);

 
 
    },
 
    methods: {
	  getDrawPolygon:function(polygon){
		    polygon.forEach(function(data) {
				console.log(data)
				this.collectionArr.push(data.point);		  	
			}.bind(this))
		    this.drawPolygons();
	  },	
      drawPolygons: function(data){
        var canvas = document.getElementById('areaCanvas');
		console.log(canvas)
		console.log(canvas.height)
        if (null == canvas || !canvas.getContext) return;
        var ctx = canvas.getContext("2d");
        // 清除画布，准备绘制
       // ctx.clearRect(0, 0, canvas.width, canvas.height);
        this.drawPolygonByPoint(ctx,null);
        var _this = this;
        canvas.onmousemove = function (e) {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          var location = _this.getLocation(canvas, e.clientX, e.clientY);
          _this.drawPolygonByPoint(ctx, location);
        };
		canvas.onmouseout=function(){
			_this.infoIndex=null;
			console.log("111")
		}
      },
      drawPolygonByPoint: function(ctx,location){
        this.collectionArr.map((pointsArr,index) =>{
          if(location != null && inside(location, pointsArr,index) == true){
            //绘制高亮图形
			//console.log(this.infoContent)
			this.infoIndex=index;
            this.drawHighLightPolygon(ctx,pointsArr,location);
			//this.drawGeneralPolygon(ctx,pointsArr);
          }else{
            //绘制一般图形
            this.drawGeneralPolygon(ctx,pointsArr);
          }
        });
      },
      drawGeneralPolygon: function(ctx,pointsArr){
        ctx.beginPath();
        for(let i = 0; i < pointsArr.length; i++){
          if(i == 0){
            ctx.moveTo(pointsArr[i][0], pointsArr[i][1]);
          }else if(i < pointsArr.length - 1){
            ctx.lineTo(pointsArr[i][0], pointsArr[i][1]);
          }else{
            ctx.lineTo(pointsArr[i][0], pointsArr[i][1]);
			//ctx.lineWidth =9;
			//ctx.strokeStyle = "red"
            //ctx.closePath();
           // ctx.stroke();
          }
        }
      },
      drawHighLightPolygon: function(ctx,pointsArr,location){
        ctx.beginPath();
		document.getElementById("textContent").style.top=location[1]-30+'px';
		document.getElementById("textContent").style.left=location[0]+20+'px'
        for(let i = 0; i < pointsArr.length; i++){
          if(i == 0){
            ctx.moveTo(pointsArr[i][0], pointsArr[i][1]);
          }else if(i < pointsArr.length - 1){
            ctx.lineTo(pointsArr[i][0], pointsArr[i][1]);
          }else{
            ctx.lineTo(pointsArr[i][0], pointsArr[i][1]);
            ctx.fillStyle="rgba(100,150,185,0.1)";
			ctx.lineWidth = 3;
			ctx.strokeStyle = "red"
            ctx.fill();
            ctx.closePath();
            ctx.stroke();
	
          }
        }
      },
      getLocation: function(canvas,x,y){
        var bbox = canvas.getBoundingClientRect();
		// console.log(canvas.width)
		// console.log(canvas.height)
		//console.log((x - bbox.left) * (canvas.width / bbox.width),(y - bbox.top) * (canvas.height / bbox.height))
        return [(x - bbox.left) * (canvas.width / bbox.width),(y - bbox.top) * (canvas.height / bbox.height)];
          /*
           * 此处不用下面两行是为了防止使用CSS和JS改变了canvas的高宽之后是表面积拉大而实际
           * 显示像素不变而造成的坐标获取不准的情况
          x: (x - bbox.left),
          y: (y - bbox.top)
          */
      },
 
    }
  }
</script>
 
<style>
	.product-canvas{width:100%;height:100%;background: url(../assets/images/tieshuibao.jpg);}
	.product-canvas .tip-content{position: absolute;}
	.product-canvas .tip-content .tip{		
		width: 230px;
		padding: 20px;
		background: #000;
		border-radius: 10px;
		border:1px solid#ccc;
		color: #fff;
	}
</style>
 
